export default __webpack_public_path__ + "static/media/inventory-report.463a8dca.jpg";